// src/stores/userStore.js
import { defineStore } from 'pinia';
import { useStorage } from '@vueuse/core';
import { encryptData,decryptData } from '@/utils/encyption';

export const useUserStore = defineStore('user', {
  state: () => ({
    productQueue: useStorage('obf_productQueue', [], localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData,
      },
    }),
    tempUserAddress1: useStorage('obf_tempUserAddress1', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    tempUserAddress2: useStorage('obf_tempUserAddress2', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    tempUserState: useStorage('obf_tempUserState', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    tempUserCity: useStorage('obf_tempUserCity', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    tempUserCountry: useStorage('obf_tempUserCountry', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    tempUserZipcode: useStorage('obf_tempUserZipcode', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    tempUserPhone: useStorage('obf_tempUserPhone', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    _tempcount: useStorage('obf_tempRandom', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    tempUserEmail: useStorage('obf_tempUserEmail', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    tempUserName: useStorage('obf_tempUserName', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    tempMcaNo: useStorage('obf_tempMcaNo', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    tempPassword: useStorage('obf_tempPassword', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    user_id: useStorage('obf_user_id', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    type: useStorage('obf_type', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    fssai: useStorage('obf_fssai', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    pan: useStorage('obf_pan', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    mcano: useStorage('obf_mcano', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    name: useStorage('obf_name', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    user_kyc_done: useStorage('obf_user_kyc_done', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    apiAccessToken: useStorage('obf_apiAccessToken', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    apiRefreshToken: useStorage('obf_apiRefreshToken', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    accessAdminToken: useStorage('obf_accessAdminToken', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    refreshAdminToken: useStorage('obf_refreshAdminToken', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    accessToken: useStorage('obf_accessToken', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    refreshToken: useStorage('obf_refreshToken', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    userdetails: useStorage('obf_userdetails', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    user_form_details: useStorage('obf_user_form_details', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    tempdata: useStorage('obf_tempdata', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    tempUserFormdata: useStorage('obf_tempUserFormdata', null, localStorage, {
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    profileData: useStorage("obf_profileData",null,localStorage,{
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    cart_id: useStorage("obf_cartid",null,localStorage,{
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    modicare_access_token: useStorage("obf_maccesstoken",null,localStorage,{
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    address_list: useStorage("obf_address_list",[],localStorage,{
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    shipping_Address: useStorage("obf_shippingaddress",null,localStorage,{
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    points_data: useStorage("obf_points_data",null,localStorage,{
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    order: useStorage("obf_order",null,localStorage,{
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    team_member_information: useStorage("obf_team_member_information",null,localStorage,{
      serializer: {
        read: decryptData,
        write: encryptData
      }
    }),
    treeData: useStorage("obf_team_tree_data",null,localStorage,{
      serializer: {
        read: decryptData,
        write: encryptData
      }
    })
  }),
  actions: {
    setUserDetails(accessToken, refreshToken ) {
      // this.mca_no = mca_no;
      // this.type = type;
      // this.fssai = fssai;
      // this.name = name;
      this.accessToken = accessToken;
      this.refreshToken = refreshToken;
    },
    setuserType(type){
      this.type=type;
    },
    setuserName(name){
      this.name=name;
    },
    setKycAvailable(value){
      this.user_kyc_done=value;
    },
    setPointsData(pointsData){
      this.points_data=pointsData;
    },
    setModicareAccessToken(token){
      this.modicare_access_token = token;
    },
    setAddressList(list){
      this.address_list = list;
    },
    setCartId(cartId){
      this.cart_id=cartId;
    },
    setType(type){
      this.type=type;
    },
    setfssai(fssai){
      this.fssai=fssai;
    },
    setPan(value){
      this.pan=value;
    },
    setmcano(no){
      this.mcano=no;
    },
    setCount(value){
      this._tempcount=value;
    },

    setApiAccessToken(token) {
      this.apiAccessToken = token;
    },

    setApiRefreshToken(token) {
      this.apiRefreshToken = token;
    },
    setTempMcano(tempMcaNo) {
      this.tempMcaNo = tempMcaNo;
    },
    setTempUserName(name) {
      this.tempUserName = name;
    },
    setTempUserEmail(email) {
      this.tempUserEmail = email;
    },
    setTempUserPhone(phone) {
      this.tempUserPhone = phone;
    },
    setTempUserAddress1(value) {
      this.tempUserAddress1 = value;
    },
    setTempUserAddress2(value) {
      this.tempUserAddress2 = value;
    },
    setTempUserCity(value) {
      this.tempUserCity = value;
    },
    setTempUserState(value) {
      this.tempUserState = value;
    },
    setTempUserZipcode(value) {
      this.tempUserZipcode = value;
    },

    setTempPassword(tempPassword) {
      this.tempPassword = tempPassword;
    },

    setAdminAccessToken(accessToken) {
      this.accessAdminToken = accessToken;
    },

    setAdminRefreshToken(refreshToken) {
      this.refreshAdminToken = refreshToken;
    },
    setAccessToken(accessToken) {
      this.accessToken = accessToken;
    },

    setRefreshToken(refreshToken) {
      this.refreshToken = refreshToken;
    },
    setMemberInformation(value) {
      this.team_member_information = value;
    },
    setTreeData(value) {
      this.treeData = value;
    },

    setTemporaryFormData(formData) {
      const encryptedData = encryptData(formData);
      this.tempdata = encryptedData;
      localStorage.setItem('obf_tempdata', encryptedData);
    },

    getTemporaryFormData() {
      const encryptedData = localStorage.getItem('obf_tempdata');
      this.tempdata = encryptedData ? decryptData(encryptedData) : null;
      return this.tempdata;
    },

    setTemporaryUserFormData(formData) {
      const encryptedData = encryptData(formData);
      this.tempUserFormdata = encryptedData;
      localStorage.setItem('obf_tempUserFormdata', encryptedData);
    },

    getTemporaryUserFormData() {
      const encryptedData = localStorage.getItem('obf_tempUserFormdata');
      this.tempUserFormdata = encryptedData ? decryptData(encryptedData) : null;
      return this.tempUserFormdata;
    },

    clearTemporaryFormData() {
      this.tempdata = null;
      localStorage.removeItem('obf_tempdata');
    },

    clearTemporaryUserFormData() {
      this.tempUserFormdata = null;
      localStorage.removeItem('obf_tempUserFormdata');
    },

    destroySession() {
      const keys = [
        'obf_user_id', 'obf_type', 'obf_fssai', 'obf_mca_no','ofc_pan',
        'obf_name', 'obf_accessToken', 'obf_refreshToken', 
        'obf_tempdata', 'obf_tempUserFormdata','obf_profileData',"obf_cartId"
      ];
      keys.forEach(key => localStorage.removeItem(key));
      
      this.$reset();
    },

    clearUserDetails() {
      this.user_id = null;
      this.mca_no = null;
      this.name = null;
      this.type = null;
      this.fssai = null;
      this.accessToken = null;
      this.refreshToken = null;
      this.profileData = null;
      this.cartId = null
    },
    clearAdminUserDetails() {
      this.accessAdminToken = null;
      this.refreshAdminToken = null;
      // this._tempcount = 0;
    },

    setUserLogout() {
      this.clearUserDetails();
      this.userdetails = null;
    },

    setProfileData(profileData) {
      this.profileData = profileData;
    },

    setShippingAddress(address) {
      this.shipping_Address = address|| null;
    },
    setOrderDetails(order) {
      this.order = order|| null;
    },
    addToProductQueue(product) {
      if (!this.productQueue.find(p => p.id === product.id)) {
        this.productQueue.push(product);
      }
    },

    // Remove a product from the queue
    removeFromProductQueue(productId) {
      this.productQueue = this.productQueue.filter(product => product.id !== productId);
    },

    // Clear the entire product queue
    clearProductQueue() {
      this.productQueue = [];
    },

    // Get the product queue
    getProductQueue() {
      return this.productQueue;
    },

    // Update a product in the queue
    updateProductInQueue(updatedProduct) {
      const index = this.productQueue.findIndex(product => product.id === updatedProduct.id);
      if (index !== -1) {
        this.productQueue[index] = updatedProduct;
      }
    },
  },
  getters: {
    getMemberInformation:(state) => state.team_member_information,
    isLoggedIn: (state) => !!state.accessToken,
    orderDetails: (state) => state.order,
    cartId: (state) => state.cart_id?.id,
    pointsData: (state) => state.points_data,
    cartDetail: (state) => state.cart_id,
    cartIsActive: (state) => state.is_active,
    shippingAddress: (state) => state.shipping_Address,
    kyc_done: (state) => state.user_kyc_done,
    modicareAccessToken: (state) => state.modicare_access_token,
    addressList: (state) => state.address_list,
    getTempUserAddress1: (state) => state.tempUserAddress1,
    getTempUserAddress2: (state) => state.tempUserAddress2,
    getTempUserState: (state) => state.tempUserState,
    getTempUserCity: (state) => state.tempUserCity,
    getTempUserCountry: (state) =>  state.tempUserCountry,
    getTempUserZipcode: (state) =>  state.tempUserZipcode,
    getProfileData: (state)=> state.profileData,
    getTempUserEmail: (state) => state.tempUserEmail,
    getTempUserName: (state) => state.tempUserName,
    getTempUserPhone: (state) => state.tempUserPhone,
    getTempMcaNo: (state) => state.tempMcaNo,
    getTempPassword: (state) => state.tempPassword,
    user_form_details: (state) => state.userdetails,
    getuserName: (state) => state.name,
    getuserType: (state) => state.type,
    getmca_no: (state) => state.mcano,
    getuserfssai: (state) => state.fssai,
    getuserPan: (state) => state.pan,
    getApiAccessToken: (state) => state.apiAccessToken,
    getApiRefreshToken: (state) => state.apiRefreshToken,
    getAccessToken: (state) => state.accessToken,
    getRefreshToken: (state) => state.refreshToken,
    getAdminAccessToken: (state) => state.accessAdminToken,
    getAdminRefreshToken: (state) => state.refreshAdminToken,
    getUserFormDetails: (state) => state.tempdata,
    getTreeData: (state) => state.treeData,
    getUserNotificationCount:(state)=>()=>state._tempcount
  },
});
